
<svg aria-hidden="true" width="32" height="32" viewBox="-2 -1 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16" cy="16" r="15.5" stroke="#6E6F74" />
  <path
    d="M11.8711 21.6367H13.5273L15.9414 13.207H16.0508L18.4727 21.6367H20.1211L23.168 10.3633H21.3477L19.2852 19.1289H19.1758L16.8086 10.3633H15.1836L12.832 19.1289H12.7227L10.6523 10.3633H8.83203L11.8711 21.6367Z"
    fill="#6E6F74"
  />
</svg>
